(function($, undefined) {
	
	'use strict';
	var utils;
	
	var init = function () {
		utils = Fw.component.models().utils;
		
		$('.texts-ctn .text').each(function(i, el) {
			utils.loadLexiqueText($(el).html(), function(text) {
				$(el).html(text);
				$(el).removeClass('processing');
			});
		});
		
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
